import selector from 'modules/Auth/selectors'
import driveSelector from 'modules/Exp-Candidates/selectors'
import Page from 'modules/Page/Components/index'
import rolesSelectors from 'modules/Roles/selectors'
import settingsSelector from 'modules/Settings/selectors'
import { connect } from 'react-redux'

import {
  checkout,
  corporateDetails,
  getListOfCities,
  getListOfCountries,
  getListOfStates,
  getNotificationsList,
  getUserInfo,
  getUserPermissions,
  getUserRoles,
  markNotificationReadApi,
  signOut,
} from 'modules/Auth/actions'
import {
  getDriveInterviewerList,
  getDriveRoleCandidatesList,
  getGroupDiscussionList,
  getInterViewLocation,
  getRoleMetrics,
  getSingleCandidateInterviewDetails,
  updateInterview,
  updateInterviewStatus,
} from 'modules/Exp-Candidates/actions'
import {
  UpdateScheudle,
  getCandidateDetails,
  getRescheduleList,
  getRoleRounds,
} from 'modules/Roles/actions'
import {
  addCorporateBranch,
  deleteLocationAPI,
  getCorporateLocationsList,
  getLocationDetails,
  updateLocationAPI,
} from 'modules/Settings/actions'

const mapStateToProps = state => ({
  corporateData: selector.getCorporateData(state),
  userData: selector?.getUserData(state),
  userRole: selector?.getUserRoleList(state),
  notificationData: selector?.getNotificationData(state),
  driveData: driveSelector.getDriveData(state),
  rolesMetrics: driveSelector.getRoleMetrics(state),
  candidateInterviewDetails: driveSelector.getCandidateInterviewDetails(state),

  notifyReschedule: rolesSelectors.getRescheduleList(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  roundItemList: rolesSelectors.getRoleRoundsList(state),
  listOfCountries: selector.getListOfCountries(state),
  listOfStates: selector.getListOfStates(state),
  listOfCities: selector.getListOfCities(state),
  driveInterViewerList: driveSelector.getDriveInterViewerList(state),
  interViewdata: driveSelector.getInterViewLocation(state),
  corporateLocationsList: settingsSelector.getCorporateLocations(state),
  groupList: driveSelector.getGroupList(state),
})

const mapDispatchToProps = {
  corporateDetails,
  getUserInfo,
  getUserRoles,
  signOut,
  checkout,
  getNotificationsList,
  markNotificationReadApi,
  getUserPermissions,
  getCorporateLocationsList,
  addCorporateBranch,
  getLocationDetails,
  updateLocationAPI,
  deleteLocationAPI,
  getDriveRoleCandidatesList,
  getRoleMetrics,
  getSingleCandidateInterviewDetails,
  updateInterview,
  updateInterviewStatus,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  getRescheduleList,
  getCandidateDetails,
  getRoleRounds,

  getDriveInterviewerList,
  getInterViewLocation,
  getGroupDiscussionList,
  UpdateScheudle,
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
